import { motion } from "framer-motion";
import {
  Home,
  Wrench,
  Droplet,
  Plug,
  HardHat,
  Trees,
  Sparkles,
  Stethoscope,
  Store,
} from "lucide-react";

const INDUSTRIES = [
  { icon: Home, name: "Roofing" },
  { icon: Wrench, name: "HVAC" },
  { icon: Droplet, name: "Plumbing" },
  { icon: Plug, name: "Electricians" },
  { icon: HardHat, name: "Construction" },
  { icon: Trees, name: "Landscaping" },
  { icon: Sparkles, name: "Cleaning" },
  { icon: Stethoscope, name: "Medical" },
  { icon: Store, name: "Local Businesses" },
];

export default function Industries() {
  return (
    <section data-testid="industries" className="section relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-300 text-xs font-semibold tracking-widest uppercase">
            Industries We Serve
          </div>
          <h2 className="mt-5 font-display text-4xl md:text-5xl font-bold tracking-tight">
            Specialists for service-based businesses.
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {INDUSTRIES.map((it, i) => (
            <motion.div
              key={it.name}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: (i % 9) * 0.04 }}
              data-testid={`industry-${i}`}
              className="group flex items-center gap-4 px-5 py-5 rounded-2xl border border-white/10 bg-white/[0.025] hover:bg-white/[0.05] hover:border-cyan-500/30 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-600/20 to-cyan-400/10 border border-white/10 flex items-center justify-center group-hover:from-blue-600/40 group-hover:to-cyan-400/30 transition-colors">
                <it.icon className="w-5 h-5 text-cyan-400" />
              </div>
              <div className="font-semibold text-white">{it.name}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
